import { ErrorWrapper } from './util'

import { OdooService } from './odoo.service'

const MODEL = 'res.groups'
// const DOMAIN = { }
// const REQUIRED_FIELDS = ['id']
// const BASIC_FIELDS = ['display_name', 'parent_id', 'is_company']
const BASIC_FIELDS = []
const OPTS = { limit: 0, order: 'id desc' }

export class GroupsService extends OdooService {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super()
  }

  static get entity () {
    return 'groups'
  }

  static async search (domain) {
    try {
      return await this.kwSearch(MODEL, domain, BASIC_FIELDS)
    } catch (error) {
      console.log(error)
    }
  }

  static async read (ids, fields = []) {
    try {
      return await this.kwRead(MODEL, ids, fields)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async list (domain) {
    try {
      return await this.kwSearchRead(MODEL, domain, BASIC_FIELDS, OPTS)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async create (data) {
    try {
      return await this.kwCreate(MODEL, data)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async delete (id) {
    try {
      return await this.kwDelete(MODEL, id)
    } catch (error) {
      // console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async update (id, data) {
    try {
      return await this.kwUpdate(MODEL, id, data)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async getGroupsToAddUser (groupName) {
    const all_groups = await this.list()
    if (all_groups) {
      // console.log('all groups', all_groups)
      const groups = [groupName, 'Internal User', 'Access Rights', 'Contact Creation']
      const group_ids = []
      for (const group of all_groups) {
        groups.forEach((element) => {
          if (element === group.name) {
            // console.log(element)
            group_ids.push(group.id)
          }
        })
        if (group_ids.length === groups.length) {
          console.log('All groups found ------ ')
          return (group_ids)
        }
      }
    }
  }
}
